import { Component, OnInit, QueryList, ViewChild } from '@angular/core';

import { CallNumber } from '@ionic-native/call-number';
import { Device } from '@ionic-native/device';

import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { TranslateService } from '@ngx-translate/core';
import {
  App,
  Events,
  IonicApp,
  MenuController,
  Modal,
  ModalController,
  Nav,
  Platform
} from 'ionic-angular';
import { AuthProvider } from '../providers/auth/auth';
import { ConfigProvider } from '../providers/base/config';
import { Util } from '../providers/base/util';
import { DataProvider } from '../providers/data/data';
import { DeviceProvider } from '../providers/device/device';
import swal from 'sweetalert';
const HOME_PAGE = 'HomePage';

import OneSignal from 'onesignal-cordova-plugin';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';

@Component({
  templateUrl: 'app.html',
  providers: [CallNumber, InAppBrowser, AuthProvider, Device, OpenNativeSettings]
})
export class MyApp implements OnInit {
  @ViewChild(Nav) nav: Nav;
  @ViewChild(Modal) myModal: QueryList<Modal>;

  rootPage: any = 'HomePage';

  pages: any;

  selectedMenu: any;

  beneficiario;

  imageUrl = './assets/imgs/background/img3.jpeg';

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public menuCtrl: MenuController,
    public util: Util,
    private deviceProvider: DeviceProvider,
    private events: Events,
    private iab: InAppBrowser,
    private callNumber: CallNumber,
    private appCtrl: App,
    private authProvider: AuthProvider,
    private ionicApp: IonicApp,
    public translateService: TranslateService,
    public dataProvider: DataProvider,
    public modalCtrl: ModalController,
    public openNativeSettings: OpenNativeSettings
  ) {
    translateService.setDefaultLang('pt');
  }

  ngOnInit(): void {
    this.initializeApp();

    this.verificarExisteBeneficiario();

    this.getSideMenuData();

    this.atualizarMenuQuandoUsuarioAutenticar();
  }

  get isAutenticado() {
    this.beneficiario = AuthProvider.getUser();
    return AuthProvider.autenticado();
  }

  atualizarMenuQuandoUsuarioAutenticar() {
    this.authProvider.loginChanged$.subscribe(() => {
      this.getSideMenuData();
    });
  }

  OneSignalInit(): void {
    OneSignal.setAppId(ConfigProvider.one_signal_id);

    OneSignal.setNotificationOpenedHandler((data) =>
      this.redirectToTeleatendimento(data)
    );

    OneSignal.setNotificationWillShowInForegroundHandler((data) =>
      this.redirectToTeleatendimento(data)
    );
    this.OneSignalRequestPermission();
  }

  OneSignalRequestPermission() {
    OneSignal.promptForPushNotificationsWithUserResponse((accept) => {
      this.PermissionNotificationRejectAndLogout(accept)
    });
  }

  PermissionNotificationRejectAndLogout(accept) {
    if(!accept){
      swal({
        title: 'Permissão para notificação!',
        text: 'As permissões de notificação para este aplicativo não estão habilitadas neste dispositivo!',
        icon: 'error'
      }).then((action) => {
        swal({
          title: 'Como ativar suas notificações!',
          text: 'Clique no botão Ir configurações. No menu notificações, deixe habilitado todas as notificações!',
          icon: "info",
          buttons: ["Sair","Ir configurações"] 
        }).then((action) => {
          if (action) {
            this.forcePermission();
          } else {
            this.forceLogout();
          }
          
        });
      });
    }   
  }

  redirectToTeleatendimento(data: any) {
    const { additionalData } = data.notification;

    const { route, link } = additionalData as any;

    if (route === 'NotificacoesPage' && link) {
      this.appCtrl.getActiveNav().setRoot('NotificacoesPage');
      const browser = this.iab.create(link, '_system');
      browser.close();
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.hide();
      this.splashScreen.hide();
      this.errorRequestEvents();
      this.OneSignalInit();
    });
  } 
  verificarExisteBeneficiario() {
    this.beneficiario = AuthProvider.getUser();

    const existeBeneficiario =
      (this.beneficiario && this.beneficiario.data.hasOwnProperty('anexo')) ||
      false;

    if (!existeBeneficiario) return;

    this.imageUrl = this.beneficiario.data.anexo.data.url;
  }

  getSideMenuData() {
    this.pages = AuthProvider.autenticado()
      ? this.dataProvider.getSideMenusAuth()
      : this.dataProvider.getSideMenus();
  }

  errorRequestEvents() {
    this.events.subscribe('unauthorized:requestError', () => {
      this.appCtrl
        .getActiveNav()
        .popToRoot()
        .then(() => {
          this.irParaPaginaDeLogin();
          this.mensagemErroSessaoExpirada();
        });
    });

    this.events.subscribe('timeout:requestError', () => {
      this.appCtrl
        .getActiveNav()
        .popToRoot()
        .then(() => {
          this.irParaPaginaDeLogin();
          this.mensagemErroConexao();
        });
    });

    this.events.subscribe('notFound:requestError', () => {
      this.appCtrl
        .getActiveNav()
        .popToRoot()
        .then(() => {
          this.irParaPaginaDeLogin();
          this.mensagemErroAplicativoIndisponivel();
        });
    });
  }

  closeModals() {
    let activeModal = this.ionicApp._modalPortal.getActive();
    if (!activeModal) return;
    activeModal.dismiss();
  }

  openPage(component, index) {
    if (component) {
      this.nav.setRoot(component);
      this.menuCtrl.close();

      return;
    }

    if (this.selectedMenu) {
      this.selectedMenu = 0;

      return;
    }

    this.selectedMenu = index;
  }

  entrar() {
    this.nav.setRoot('SignInPage');
  }

  logout() {
    const load = this.util.createLoading('Saindo...');

    this.deviceProvider.desregister().subscribe(
      () => {
        OneSignal.removeExternalUserId();
        AuthProvider.deslogar();
        this.getSideMenuData();
        this.nav.setRoot(HOME_PAGE);
        load.dismiss();
      },
      () => {
        load.dismiss();
      }
    );
  }

  forceLogout() {
    const load = this.util.createLoading('Saindo...');

    this.deviceProvider.desregister().subscribe(
      () => {
        OneSignal.removeExternalUserId();
        AuthProvider.deslogar();
        this.getSideMenuData();
        this.nav.setRoot(HOME_PAGE);
        load.dismiss();
      },
      () => {
        load.dismiss();
      },
      () => {
        this.platform.exitApp();        
      }
    );
  }
  forcePermission() {
    const load = this.util.createLoading('Saindo...');

    this.deviceProvider.desregister().subscribe(
      () => {
        OneSignal.removeExternalUserId();
        AuthProvider.deslogar();
        this.getSideMenuData();
        this.nav.setRoot(HOME_PAGE);
        load.dismiss();
      },
      () => {
        load.dismiss();
      },
      () => {
        this.openNativeSettings.open(["application_details",true]);
        this.platform.exitApp();     
      }
    );
  }

  abrirAjuda() {
    const abrirWhatsApp = {
      text: 'WhatsApp',
      icon: 'logo-whatsapp',
      handler: () => {
        const isMobileWeb = this.platform.is('mobileweb');

        if (isMobileWeb) {
          window.open(
            'https://api.whatsapp.com/send?1=pt_BR&phone=5563992127345',
            '_system'
          );
          return;
        }

        window.open('whatsapp://send?1=pt_BR&phone=+5563992127345', '_system');
      }
    };

    const ligarPeloWhatsApp = {
      text: 'Ligar',
      icon: 'call',
      handler: () => {
        this.chamar();
      }
    };

    const voltar = {
      text: 'Voltar',
      role: 'destructive',
      handler: () => {}
    };

    this.util.criarActionSheet('Como podemos te ajudar?', [
      abrirWhatsApp,
      ligarPeloWhatsApp,
      voltar
    ]);
  }

  chamar() {
    const { numeroWhatsApp } = ConfigProvider;

    this.callNumber
      .callNumber(numeroWhatsApp, true)
      .then(() => {})
      .catch(() => this.messageErrorCall());
  }

  irParaPaginaDeLogin() {
    this.closeModals();
    this.appCtrl.getRootNav().setRoot('SignInPage');
  }

  mensagemErroAplicativoIndisponivel() {
    this.util.criarAlert(
      'Aplicativo Indisponível',
      'Por favor entre em contato com o suporte.',
      'OK'
    );
  }

  messageErrorCall() {
    this.util.criarAlert(
      'Erro!',
      'A plataforma que você está utilizando não oferece suporte a essa funcionalidade. ',
      'ok'
    );
  }

  mensagemErroSessaoExpirada() {
    this.util.criarAlert(
      'Sessão expirada',
      'Por favor realize o login novamente.',
      'OK'
    );
  }

  mensagemErroConexao() {
    this.util.criarAlert(
      'Erro ao conectar',
      'Por favor verifique a sua conexão com a internet.',
      'OK'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts